// Websafe Fonts that should be available on all devices
export default [
  'Helvetica',
  'Times New Roman',
];